<template>
  <v-card
    class="p-7"
    tile>
    <div class="close-popup">
      <v-btn
        icon
        small
        @click="$emit('close')">
        <v-icon small>
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="flex justify-center">
      <v-icon
        color="error"
        class="w-10"
        size="40">
        mdi-delete
      </v-icon>
    </div>
    <span class="font-medium text-center mt-7 mb-2">
      คุณต้องการลบข้อมูล?
    </span>
    <span
      v-if="canRemove"
      class="text-field-gray text-sm text-center">
      ระบบจะลบข้อมูลทั้งหมดที่คุณเลือก
    </span>
    <div
      v-else
      class="error--text text-center">
      {{ canNotRemoveMessage }}
    </div>
    <v-divider class="my-7" />
    <div class="flex justify-end gap-4">
      <v-btn
        color="blue darken-1"
        text
        @click="$emit('close')">
        ยกเลิก
      </v-btn>
      <v-btn
        v-if="canRemove"
        color="error"
        depressed
        rounded
        :dark="!loading"
        :disabled="loading"
        @click="$emit('confirm')">
        <v-progress-circular
          v-if="loading"
          class="mr-2"
          size="16"
          width="2"
          indeterminate />
        ยืนยันลบข้อมูล
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    canRemove: {
      type: Boolean,
      default: true
    },
    canNotRemoveMessage: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>

<style scoped>

</style>
